import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import ResponsiveFixedPortalWrapper from '../../misc/ResponsiveFixedPortalWrapper';
import { triggerStateChangeForGivenTime } from '../../../utils/common';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { HelpdeskWidgetContext } from '../HelpdeskWidget';
import { shouldFotoFlatBeDisplayed } from '../../../utils/common';
import { ALTERNATIVE, MAIN_SEARCH, PARTICIPANT } from '../../../utils/variables';

const EventSearchMainActions = ({
  onShowOfferClick,
  onFindMorePhotosClick,
  event,
  userLoginEmail,
  onScrollToForm,
  onGoBackToMainSearch,
  participantMediaCount,
  setElementToAnimate,
}) => {
  const history = useHistory();

  const [hlpDskState, hlpDskDispatch] = useContext(HelpdeskWidgetContext);

  const onHelpClick = () => {
    const userAcceptsCookies = localStorage.getItem('userAcceptsStatsCookies') === 'true';

    if (userAcceptsCookies) {
      {
        event.sgId && hlpDskDispatch({ type: 'eventId', payload: event.sgId });
      }
      {
        event.name && hlpDskDispatch({ type: 'eventName', payload: event.name });
      }
      {
        userLoginEmail && hlpDskDispatch({ type: 'email', payload: userLoginEmail });
      }
      hlpDskDispatch({ type: 'open', payload: true });
    } else {
      history.push(`/contact`);
    }
  };

  // Always sends the participant list type, there is another logic for converting the FF offer into a "go back" button in alt. search results.
  const shouldScrollToFotoFlatOffer = shouldFotoFlatBeDisplayed(
    participantMediaCount,
    PARTICIPANT,
    event.products,
    event.pendingMediaProcessing
  );

  return (
    <ResponsiveFixedPortalWrapper>
      <div className="row">
        <div className="col-xs-16 col-sm-12 col-sm-offset-2 mb-40 event-search-actions-container">
          {onShowOfferClick && shouldScrollToFotoFlatOffer && (
            <button
              className="btn btn-default warning-btn main-action-btn"
              onClick={() => onShowOfferClick()}
            >
              <FormattedMessageWrappedInSpan
                id="eventSearchMainActions.showOffer"
                defaultMessage="Show offer"
              />
            </button>
          )}
          {!onShowOfferClick && onGoBackToMainSearch && shouldScrollToFotoFlatOffer && (
            <button
              className="btn btn-default primary-btn primary-new medium main-action-btn"
              onClick={() => onGoBackToMainSearch()}
            >
              <FormattedMessageWrappedInSpan
                id="eventSearchMainActions.goBackToMain"
                defaultMessage="Go to offer"
              />
            </button>
          )}
          {onScrollToForm && (
            <button
              className="btn btn-default secondary-btn secondary-new medium"
              onClick={() => {
                onScrollToForm();
                triggerStateChangeForGivenTime(
                  setElementToAnimate,
                  MAIN_SEARCH,
                  null,
                  2000
                );
              }}
            >
              <FormattedMessageWrappedInSpan
                id="eventSearchMainActions.searchAgain"
                defaultMessage="Search again"
              />
            </button>
          )}
          {onFindMorePhotosClick && (
            <button
              className={classNames('btn btn-default medium', {
                'secondary-btn secondary-new': shouldScrollToFotoFlatOffer,
                'primary-btn primary-new main-action-btn': !shouldScrollToFotoFlatOffer,
              })}
              onClick={() => {
                onFindMorePhotosClick();
                triggerStateChangeForGivenTime(
                  setElementToAnimate,
                  ALTERNATIVE,
                  null,
                  2000
                );
              }}
            >
              <FormattedMessageWrappedInSpan
                id="eventSearchMainActions.findMorePhotos"
                defaultMessage="Find more photos"
              />
            </button>
          )}
          {!onScrollToForm && onGoBackToMainSearch && (
            <button
              className="btn btn-default secondary-btn secondary-new medium"
              onClick={() => onGoBackToMainSearch()}
            >
              <FormattedMessageWrappedInSpan
                id="eventSearchMainActions.searchAgain"
                defaultMessage="Search again"
              />
            </button>
          )}
          <button
            className="btn btn-default secondary-btn secondary-new medium"
            onClick={() => onHelpClick()}
          >
            <FormattedMessageWrappedInSpan
              id="eventSearchMainActions.needHelp"
              defaultMessage="Need help"
            />
          </button>
        </div>
      </div>
    </ResponsiveFixedPortalWrapper>
  );
};

EventSearchMainActions.propTypes = {
  onShowOfferClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onFindMorePhotosClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  event: PropTypes.object,
  userLoginEmail: PropTypes.string,
  onScrollToForm: PropTypes.func,
  onGoBackToMainSearch: PropTypes.func,
  participantMediaCount: PropTypes.number,
  setElementToAnimate: PropTypes.func,
};

export { EventSearchMainActions };

export default createFragmentContainer(EventSearchMainActions, {
  event: graphql`
    fragment EventSearchMainActions_event on Event {
      name
      sgId
      pendingMediaProcessing
      products {
        id
        mediaCollection {
          name
        }
        price
        type
      }
    }
  `,
});
